/* eslint-disable */
// Approved list
import structures$RoomView from 'matrix-react-sdk/lib/components/structures/RoomView'
import views$elements$ErrorBoundary from 'matrix-react-sdk/lib/components/views/elements/ErrorBoundary'
import views$avatars$RoomAvatar from 'matrix-react-sdk/lib/components/views/avatars/RoomAvatar'
import views$elements$AccessibleButton from 'matrix-react-sdk/lib/components/views/elements/AccessibleButton'
import views$elements$ManageIntegsButton from 'matrix-react-sdk/lib/components/views/elements/ManageIntegsButton'
import views$right_panel$RoomHeaderButtons from 'matrix-react-sdk/lib/components/views/right_panel/RoomHeaderButtons'
import structures$MainSplit from 'matrix-react-sdk/lib/components/structures/MainSplit'
import views$rooms$AuxPanel from 'matrix-react-sdk/lib/components/views/rooms/AuxPanel'
import views$rooms$AppsDrawer from 'matrix-react-sdk/lib/components/views/rooms/AppsDrawer'
import structures$ScrollPanel from 'matrix-react-sdk/lib/components/structures/ScrollPanel'
import structures$AutoHideScrollbar from 'matrix-react-sdk/lib/components/structures/AutoHideScrollbar'
import views$messages$DateSeparator from 'matrix-react-sdk/lib/components/views/messages/DateSeparator'
import views$elements$ProgressBar from 'matrix-react-sdk/lib/components/views/elements/ProgressBar'
import views$elements$MemberEventListSummary from 'matrix-react-sdk/lib/components/views/elements/MemberEventListSummary'
import views$messages$TextualEvent from 'matrix-react-sdk/lib/components/views/messages/TextualEvent'
import views$messages$MessageTimestamp from 'matrix-react-sdk/lib/components/views/messages/MessageTimestamp'
import views$messages$ReactionsRow from 'matrix-react-sdk/lib/components/views/messages/ReactionsRow'
import views$messages$MessageOverlay from 'matrix-react-sdk/lib/components/views/messages/MessageOverlay'
import views$elements$InteractiveTooltip from 'matrix-react-sdk/lib/components/views/elements/InteractiveTooltip'
import structures$RoomStatusBar from 'matrix-react-sdk/lib/components/structures/RoomStatusBar'
import views$rooms$MessageComposerFormatBar from 'matrix-react-sdk/lib/components/views/rooms/MessageComposerFormatBar'
import views$rooms$Stickerpicker from 'matrix-react-sdk/lib/components/views/rooms/Stickerpicker'
import views$rooms$TopUnreadMessagesBar from 'matrix-react-sdk/lib/components/views/rooms/TopUnreadMessagesBar'
import views$elements$Pill from 'matrix-react-sdk/lib/components/views/elements/Pill'
import structures$ContextualMenu from 'matrix-react-sdk/lib/components/structures/ContextualMenu'
import views$rooms$EditMessageComposer from 'matrix-react-sdk/lib/components/views/rooms/EditMessageComposer'
import views$messages$MFileBody from 'matrix-react-sdk/lib/components/views/messages/MFileBody'
import views$messages$MImageBody from 'matrix-react-sdk/lib/components/views/messages/MImageBody'
import views$messages$MVideoBody from 'matrix-react-sdk/lib/components/views/messages/MVideoBody'
import views$messages$MAudioBody from 'matrix-react-sdk/lib/components/views/messages/MAudioBody'
import views$messages$MFileTypeBody from 'matrix-react-sdk/lib/components/views/messages/MFileTypeBody'
import views$dialogs$BaseDialog from 'matrix-react-sdk/lib/components/views/dialogs/BaseDialog'
import views$rooms$RoomDropTarget from 'matrix-react-sdk/lib/components/views/rooms/RoomDropTarget'
import structures$UploadBar from 'matrix-react-sdk/lib/components/structures/UploadBar'
import views$elements$DialogButtons from 'matrix-react-sdk/lib/components/views/elements/DialogButtons'
import views$elements$ImageView from 'matrix-react-sdk/lib/components/views/elements/ImageView'
import views$context_menus$GenericElementContextMenu from 'matrix-react-sdk/lib/components/views/context_menus/GenericElementContextMenu'
import views$messages$ReactionsRowButton from 'matrix-react-sdk/lib/components/views/messages/ReactionsRowButton'
import views$emojipicker$ReactionPicker from 'matrix-react-sdk/lib/components/views/emojipicker/ReactionPicker'
import views$elements$LazyRenderList from 'matrix-react-sdk/lib/components/views/elements/LazyRenderList'
import views$dialogs$QuestionDialog from 'matrix-react-sdk/lib/components/views/dialogs/QuestionDialog'
import views$context_menus$MessageContextMenu from 'matrix-react-sdk/lib/components/views/context_menus/MessageContextMenu'
import views$dialogs$ConfirmRedactDialog from 'matrix-react-sdk/lib/components/views/dialogs/ConfirmRedactDialog'
import views$dialogs$ConfirmAndWaitRedactDialog from 'matrix-react-sdk/lib/components/views/dialogs/ConfirmAndWaitRedactDialog'
import views$dialogs$UploadFailureDialog from 'matrix-react-sdk/lib/components/views/dialogs/UploadFailureDialog'
import views$dialogs$ErrorDialog from 'matrix-react-sdk/lib/components/views/dialogs/ErrorDialog'
import views$rooms$LinkPreviewWidget from 'matrix-react-sdk/lib/components/views/rooms/LinkPreviewWidget'

import Empty from './Empty'

// Overrides
import views$elements$GeminiScrollbarWrapper from './GeminiScrollbarWrapper'
import views$rooms$BasicMessageComposer from './BasicMessageComposer'
import views$messages$MessageActionBar from './MessageActionBar'
import views$rooms$MessageComposer from './MessageComposer'
import structures$MessagePanel from './MessagePanel'
import views$messages$ViewSourceEvent from './Events'
import views$messages$StateEvent from './Events/StateEvent'
import views$rooms$SendMessageComposer from './SendMessageComposer'
import views$avatars$MemberAvatar from './MemberAvatar'
import views$rooms$EventTile from './EventTile'
import views$emojipicker$EmojiPicker from './EmojiPicker'
import views$rooms$EmojiPickerButton from './EmojiPickerButton'
import views$messages$ReactionsRowAddButton from './ReactionsRowAddButton'
import views$rooms$ReplyPreview from './ReplyPreview'
import views$messages$ShadowBody from './ShadowBody'
import views$messages$MessageEvent from './MessageEvent'
import views$messages$TextualBody from './TextualBody'
import views$dialogs$UploadConfirmDialog from './UploadConfirmDialog'
import views$rooms$WhoIsTypingTile from './WhoIsTypingTile'
import views$avatars$BaseAvatar from './BaseAvatar'
import structures$TimelinePanel from './TimelinePanel'

const components = {}

components['views.rooms.LinkPreviewWidget'] = views$rooms$LinkPreviewWidget
components['views.dialogs.ErrorDialog'] = views$dialogs$ErrorDialog
components[
  'views.dialogs.UploadFailureDialog'
] = views$dialogs$UploadFailureDialog
components[
  'views.dialogs.ConfirmAndWaitRedactDialog'
] = views$dialogs$ConfirmAndWaitRedactDialog
components[
  'views.dialogs.ConfirmRedactDialog'
] = views$dialogs$ConfirmRedactDialog
components[
  'views.context_menus.MessageContextMenu'
] = views$context_menus$MessageContextMenu
components['views.dialogs.QuestionDialog'] = views$dialogs$QuestionDialog
components['views.avatars.BaseAvatar'] = views$avatars$BaseAvatar
components['views.elements.LazyRenderList'] = views$elements$LazyRenderList
components[
  'views.emojipicker.ReactionPicker'
] = views$emojipicker$ReactionPicker
components['views.emojipicker.EmojiPicker'] = views$emojipicker$EmojiPicker
components[
  'views.messages.ReactionsRowButton'
] = views$messages$ReactionsRowButton

components[
  'views.context_menus.GenericElementContextMenu'
] = views$context_menus$GenericElementContextMenu
components[
  'views.messages.ReactionsRowAddButton'
] = views$messages$ReactionsRowAddButton
components['views.elements.ImageView'] = views$elements$ImageView
components['views.elements.DialogButtons'] = views$elements$DialogButtons

components['structures.UploadBar'] = structures$UploadBar
components['views.rooms.RoomDropTarget'] = views$rooms$RoomDropTarget
components['views.dialogs.BaseDialog'] = views$dialogs$BaseDialog

components[
  'views.dialogs.UploadConfirmDialog'
] = views$dialogs$UploadConfirmDialog
components['views.messages.MFileTypeBody'] = views$messages$MFileTypeBody
components['views.messages.MAudioBody'] = views$messages$MAudioBody
components['views.messages.MVideoBody'] = views$messages$MVideoBody
components['views.messages.MImageBody'] = views$messages$MImageBody
components['views.messages.MFileBody'] = views$messages$MFileBody
components['views.rooms.EditMessageComposer'] = views$rooms$EditMessageComposer
components['structures.ContextualMenu'] = structures$ContextualMenu
components['views.elements.Pill'] = views$elements$Pill
components['views.messages.MessageEvent'] = views$messages$MessageEvent
components['views.messages.ShadowBody'] = views$messages$ShadowBody
components['views.messages.ViewSourceEvent'] = views$messages$ViewSourceEvent
components['views.messages.StateEvent'] = views$messages$StateEvent
components['views.messages.TextualBody'] = views$messages$TextualBody
components['views.messages.MessageOverlay'] = views$messages$MessageOverlay
components['views.rooms.Stickerpicker'] = views$rooms$Stickerpicker
components[
  'views.rooms.MessageComposerFormatBar'
] = views$rooms$MessageComposerFormatBar
components['views.rooms.ReplyPreview'] = views$rooms$ReplyPreview
components['views.rooms.SendMessageComposer'] = views$rooms$SendMessageComposer
components['structures.RoomStatusBar'] = structures$RoomStatusBar
components['views.rooms.WhoIsTypingTile'] = views$rooms$WhoIsTypingTile
components[
  'views.elements.InteractiveTooltip'
] = views$elements$InteractiveTooltip
components['views.messages.ReactionsRow'] = views$messages$ReactionsRow
components['views.messages.MessageTimestamp'] = views$messages$MessageTimestamp
components['views.messages.TextualEvent'] = views$messages$TextualEvent
components['views.rooms.EventTile'] = views$rooms$EventTile
components[
  'views.elements.MemberEventListSummary'
] = views$elements$MemberEventListSummary
components['views.avatars.MemberAvatar'] = views$avatars$MemberAvatar
components['views.messages.DateSeparator'] = views$messages$DateSeparator
components['structures.AutoHideScrollbar'] = structures$AutoHideScrollbar
components['structures.ScrollPanel'] = structures$ScrollPanel
components['structures.TimelinePanel'] = structures$TimelinePanel
components['views.rooms.AppsDrawer'] = views$rooms$AppsDrawer
components['views.rooms.AuxPanel'] = views$rooms$AuxPanel
components['structures.MainSplit'] = structures$MainSplit
components[
  'views.right_panel.RoomHeaderButtons'
] = views$right_panel$RoomHeaderButtons
components[
  'views.elements.ManageIntegsButton'
] = views$elements$ManageIntegsButton
components['views.elements.AccessibleButton'] = views$elements$AccessibleButton
components['views.avatars.RoomAvatar'] = views$avatars$RoomAvatar
components['views.elements.ErrorBoundary'] = views$elements$ErrorBoundary
components['structures.RoomView'] = structures$RoomView

components[
  'views.elements.GeminiScrollbarWrapper'
] = views$elements$GeminiScrollbarWrapper
components[
  'views.rooms.BasicMessageComposer'
] = views$rooms$BasicMessageComposer
components['views.messages.MessageActionBar'] = views$messages$MessageActionBar
components['views.rooms.MessageComposer'] = views$rooms$MessageComposer
components['structures.MessagePanel'] = structures$MessagePanel
components['views.rooms.EmojiPickerButton'] = views$rooms$EmojiPickerButton
components['views.elements.ProgressBar'] = views$elements$ProgressBar
components[
  'views.rooms.TopUnreadMessagesBar'
] = views$rooms$TopUnreadMessagesBar

// Removed
components['views.rooms.JumpToBottomButton'] = Empty
components['views.dialogs.ShareDialog'] = Empty
components['views.rooms.ReadReceiptMarker'] = Empty
components['views.elements.EventListSummary'] = Empty
components['views.voip.VideoView'] = Empty
components['views.voip.CallView'] = Empty
components['views.rooms.RoomHeader'] = Empty
components['structures.CompatibilityPage'] = Empty
components['structures.CustomRoomTagPanel'] = Empty
components['structures.EmbeddedPage'] = Empty
components['structures.FilePanel'] = Empty
components['structures.GenericErrorPage'] = Empty
components['structures.GroupView'] = Empty
components['structures.IndicatorScrollbar'] = Empty
components['structures.InteractiveAuth'] = Empty
components['structures.LeftPanel'] = Empty
components['structures.LoggedInView'] = Empty
components['structures.MatrixChat'] = Empty
components['structures.MyGroups'] = Empty
components['structures.NotificationPanel'] = Empty
components['structures.RightPanel'] = Empty
components['structures.RoomDirectory'] = Empty
components['structures.RoomSubList'] = Empty
components['structures.TabbedView'] = Empty
components['structures.TagPanel'] = Empty
components['structures.TagPanelButtons'] = Empty
components['structures.ToastContainer'] = Empty
components['structures.TopLeftMenuButton'] = Empty
components['structures.UserView'] = Empty
components['structures.ViewSource'] = Empty
components['structures.auth.ForgotPassword'] = Empty
components['structures.auth.Login'] = Empty
components['structures.auth.PostRegistration'] = Empty
components['structures.auth.Registration'] = Empty
components['structures.auth.SoftLogout'] = Empty
components['views.auth.AuthBody'] = Empty
components['views.auth.AuthFooter'] = Empty
components['views.auth.AuthHeader'] = Empty
components['views.auth.AuthHeaderLogo'] = Empty
components['views.auth.AuthPage'] = Empty
components['views.auth.CaptchaForm'] = Empty
components['views.auth.CountryDropdown'] = Empty
components['views.auth.CustomServerDialog'] = Empty
components['views.auth.InteractiveAuthEntryComponents'] = Empty
components['views.auth.LanguageSelector'] = Empty
components['views.auth.ModularServerConfig'] = Empty
components['views.auth.PasswordLogin'] = Empty
components['views.auth.RegistrationForm'] = Empty
components['views.auth.ServerConfig'] = Empty
components['views.auth.ServerTypeSelector'] = Empty
components['views.auth.SignInToText'] = Empty
components['views.auth.Welcome'] = Empty
components['views.avatars.GroupAvatar'] = Empty
components['views.avatars.MemberStatusMessageAvatar'] = Empty
components['views.context_menus.GenericTextContextMenu'] = Empty
components['views.context_menus.GroupInviteTileContextMenu'] = Empty
components['views.context_menus.RoomTileContextMenu'] = Empty
components['views.context_menus.StatusMessageContextMenu'] = Empty
components['views.context_menus.TagTileContextMenu'] = Empty
components['views.context_menus.TopLeftMenu'] = Empty
components['views.context_menus.WidgetContextMenu'] = Empty
components['views.create_room.CreateRoomButton'] = Empty
components['views.create_room.Presets'] = Empty
components['views.create_room.RoomAlias'] = Empty
components['views.dialogs.AddressPickerDialog'] = Empty
components['views.dialogs.AskInviteAnywayDialog'] = Empty
components['views.dialogs.BugReportDialog'] = Empty
components['views.dialogs.ChangelogDialog'] = Empty
components['views.dialogs.ConfirmUserActionDialog'] = Empty
components['views.dialogs.ConfirmWipeDeviceDialog'] = Empty
components['views.dialogs.CreateGroupDialog'] = Empty
components['views.dialogs.CreateRoomDialog'] = Empty
components['views.dialogs.CryptoStoreTooNewDialog'] = Empty
components['views.dialogs.DeactivateAccountDialog'] = Empty
components['views.dialogs.DeviceVerifyDialog'] = Empty
components['views.dialogs.DevtoolsDialog'] = Empty
components['views.dialogs.IncomingSasDialog'] = Empty
components['views.dialogs.InfoDialog'] = Empty
components['views.dialogs.IntegrationsDisabledDialog'] = Empty
components['views.dialogs.IntegrationsImpossibleDialog'] = Empty
components['views.dialogs.InteractiveAuthDialog'] = Empty
components['views.dialogs.KeyShareDialog'] = Empty
components['views.dialogs.LazyLoadingDisabledDialog'] = Empty
components['views.dialogs.LazyLoadingResyncDialog'] = Empty
components['views.dialogs.LogoutDialog'] = Empty
components['views.dialogs.MessageEditHistoryDialog'] = Empty
components['views.dialogs.RedesignFeedbackDialog'] = Empty
components['views.dialogs.ReportEventDialog'] = Empty
components['views.dialogs.RoomSettingsDialog'] = Empty
components['views.dialogs.RoomUpgradeDialog'] = Empty
components['views.dialogs.RoomUpgradeWarningDialog'] = Empty
components['views.dialogs.SessionRestoreErrorDialog'] = Empty
components['views.dialogs.SetEmailDialog'] = Empty
components['views.dialogs.SetMxIdDialog'] = Empty
components['views.dialogs.SetPasswordDialog'] = Empty
components['views.dialogs.SlashCommandHelpDialog'] = Empty
components['views.dialogs.StorageEvictedDialog'] = Empty
components['views.dialogs.TabbedIntegrationManagerDialog'] = Empty
components['views.dialogs.TermsDialog'] = Empty
components['views.dialogs.TextInputDialog'] = Empty
components['views.dialogs.UnknownDeviceDialog'] = Empty
components['views.dialogs.UserSettingsDialog'] = Empty
components['views.dialogs.WidgetOpenIDPermissionsDialog'] = Empty
components['views.dialogs.keybackup.RestoreKeyBackupDialog'] = Empty
components['views.directory.NetworkDropdown'] = Empty
components['views.elements.AccessibleTooltipButton'] = Empty
components['views.elements.ActionButton'] = Empty
components['views.elements.AddressSelector'] = Empty
components['views.elements.AddressTile'] = Empty
components['views.elements.AppPermission'] = Empty
components['views.elements.AppTile'] = Empty
components['views.elements.AppWarning'] = Empty
components['views.elements.CreateRoomButton'] = Empty
components['views.elements.DNDTagTile'] = Empty
components['views.elements.DeviceVerifyButtons'] = Empty
components['views.elements.DirectorySearchBox'] = Empty
components['views.elements.Dropdown'] = Empty
components['views.elements.EditableItemList'] = Empty
components['views.elements.EditableText'] = Empty
components['views.elements.EditableTextContainer'] = Empty
components['views.elements.Flair'] = Empty
components['views.elements.FormButton'] = Empty
components['views.elements.GroupsButton'] = Empty
components['views.elements.IconButton'] = Empty
components['views.elements.InlineSpinner'] = Empty
components['views.elements.LabelledToggleSwitch'] = Empty
components['views.elements.LanguageDropdown'] = Empty
components['views.elements.PersistedElement'] = Empty
components['views.elements.PersistentApp'] = Empty
components['views.elements.PowerSelector'] = Empty
components['views.elements.ReplyThread'] = Empty
components['views.elements.ResizeHandle'] = Empty
components['views.elements.RoomAliasField'] = Empty
components['views.elements.RoomDirectoryButton'] = Empty
components['views.elements.SettingsFlag'] = Empty
components['views.elements.Spinner'] = Empty
components['views.elements.Spoiler'] = Empty
components['views.elements.StartChatButton'] = Empty
components['views.elements.SyntaxHighlight'] = Empty
components['views.elements.TagTile'] = Empty
components['views.elements.TextWithTooltip'] = Empty
components['views.elements.TintableSvg'] = Empty
components['views.elements.TintableSvgButton'] = Empty
components['views.elements.ToggleSwitch'] = Empty
components['views.elements.Tooltip'] = Empty
components['views.elements.TooltipButton'] = Empty
components['views.elements.TruncatedList'] = Empty
components['views.elements.UserSelector'] = Empty
components['views.elements.Validation'] = Empty
components['views.emojipicker.recent'] = Empty
components['views.emojipicker.Emoji'] = Empty
components['views.emojipicker.Category'] = Empty
components['views.emojipicker.Search'] = Empty
components['views.emojipicker.Header'] = Empty
components['views.emojipicker.QuickReactions'] = Empty
components['views.emojipicker.Preview'] = Empty
components['views.globals.CookieBar'] = Empty
components['views.globals.MatrixToolbar'] = Empty
components['views.globals.NewVersionBar'] = Empty
components['views.globals.PasswordNagBar'] = Empty
components['views.globals.ServerLimitBar'] = Empty
components['views.globals.UpdateCheckBar'] = Empty
components['views.groups.GroupInviteTile'] = Empty
components['views.groups.GroupMemberInfo'] = Empty
components['views.groups.GroupMemberList'] = Empty
components['views.groups.GroupMemberTile'] = Empty
components['views.groups.GroupPublicityToggle'] = Empty
components['views.groups.GroupRoomInfo'] = Empty
components['views.groups.GroupRoomList'] = Empty
components['views.groups.GroupRoomTile'] = Empty
components['views.groups.GroupTile'] = Empty
components['views.groups.GroupUserSettings'] = Empty
components['views.messages.EditHistoryMessage'] = Empty
components['views.messages.MStickerBody'] = Empty
components['views.messages.MjolnirBody'] = Empty
components['views.messages.MKeyVerificationConclusion'] = Empty
components['views.messages.MKeyVerificationRequest'] = Empty
components['views.messages.ReactionsRowButtonTooltip'] = Empty
components['views.messages.RoomAvatarEvent'] = Empty
components['views.messages.RoomCreate'] = Empty
components['views.messages.SenderProfile'] = Empty
components['views.messages.UnknownBody'] = Empty
components['views.right_panel.GroupHeaderButtons'] = Empty
components['views.right_panel.HeaderButton'] = Empty
components['views.right_panel.HeaderButtons'] = Empty
components['views.right_panel.UserInfo'] = Empty
components['views.room_settings.AliasSettings'] = Empty
components['views.room_settings.ColorSettings'] = Empty
components['views.room_settings.RelatedGroupSettings'] = Empty
components['views.room_settings.RoomProfileSettings'] = Empty
components['views.room_settings.UrlPreviewSettings'] = Empty
components['views.rooms.E2EIcon'] = Empty
components['views.rooms.EntityTile'] = Empty
components['views.rooms.ForwardMessage'] = Empty
components['views.rooms.MemberDeviceInfo'] = Empty
components['views.rooms.MemberInfo'] = Empty
components['views.rooms.MemberList'] = Empty
components['views.rooms.MemberTile'] = Empty
components['views.rooms.PinnedEventTile'] = Empty
components['views.rooms.PinnedEventsPanel'] = Empty
components['views.rooms.PresenceLabel'] = Empty
components['views.rooms.RoomDetailList'] = Empty
components['views.rooms.RoomDetailRow'] = Empty
components['views.rooms.RoomList'] = Empty
components['views.rooms.RoomNameEditor'] = Empty
components['views.rooms.RoomPreviewBar'] = Empty
components['views.rooms.RoomRecoveryReminder'] = Empty
components['views.rooms.RoomTile'] = Empty
components['views.rooms.RoomTopicEditor'] = Empty
components['views.rooms.RoomUpgradeWarningBar'] = Empty
components['views.rooms.SearchBar'] = Empty
components['views.rooms.SearchResultTile'] = Empty
components['views.rooms.SearchableEntityList'] = Empty
components['views.rooms.SimpleRoomHeader'] = Empty
components['views.rooms.SlateMessageComposer'] = Empty
components['views.rooms.ThirdPartyMemberInfo'] = Empty

components['views.rooms.UserTile'] = Empty
components['views.settings.ChangeAvatar'] = Empty
components['views.settings.ChangeDisplayName'] = Empty
components['views.settings.ChangePassword'] = Empty
components['views.settings.DevicesPanel'] = Empty
components['views.settings.DevicesPanelEntry'] = Empty
components['views.settings.EnableNotificationsButton'] = Empty
components['views.settings.IntegrationManager'] = Empty
components['views.settings.KeyBackupPanel'] = Empty
components['views.settings.Notifications'] = Empty
components['views.settings.ProfileSettings'] = Empty
components['views.settings.SetIdServer'] = Empty
components['views.settings.SetIntegrationManager'] = Empty
components['views.settings.account.EmailAddresses'] = Empty
components['views.settings.account.PhoneNumbers'] = Empty
components['views.settings.discovery.EmailAddresses'] = Empty
components['views.settings.discovery.PhoneNumbers'] = Empty
components['views.settings.tabs.room.AdvancedRoomSettingsTab'] = Empty
components['views.settings.tabs.room.GeneralRoomSettingsTab'] = Empty
components['views.settings.tabs.room.NotificationSettingsTab'] = Empty
components['views.settings.tabs.room.RolesRoomSettingsTab'] = Empty
components['views.settings.tabs.room.SecurityRoomSettingsTab'] = Empty
components['views.settings.tabs.user.FlairUserSettingsTab'] = Empty
components['views.settings.tabs.user.GeneralUserSettingsTab'] = Empty
components['views.settings.tabs.user.HelpUserSettingsTab'] = Empty
components['views.settings.tabs.user.LabsUserSettingsTab'] = Empty
components['views.settings.tabs.user.MjolnirUserSettingsTab'] = Empty
components['views.settings.tabs.user.NotificationUserSettingsTab'] = Empty
components['views.settings.tabs.user.PreferencesUserSettingsTab'] = Empty
components['views.settings.tabs.user.SecurityUserSettingsTab'] = Empty
components['views.settings.tabs.user.VoiceUserSettingsTab'] = Empty
components['views.terms.InlineTermsAgreement'] = Empty
components['views.toasts.VerificationRequestToast'] = Empty
components['views.verification.VerificationCancelled'] = Empty
components['views.verification.VerificationComplete'] = Empty
components['views.verification.VerificationShowSas'] = Empty
components['views.voip.CallPreview'] = Empty
components['views.voip.IncomingCallBox'] = Empty
components['views.voip.VideoFeed'] = Empty

export { components }
/* eslint-enable */
